'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cleanObject;

var _isEmpty = require('./isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Applies properties from "config" if they are undefined in "object.
 *
 * @param {Object} object The object to be cleaned
 * @param {Function} isEmptyFn Optional isEmpty function
 * @returns {Object} A new cleaned object
 *
 * @example
 * let object = {id: 1, name: undefined}
 * objectClean(object); // returns: {id: 1}
 */

function cleanObject(object) {
    var isEmptyFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _isEmpty2.default;

    return Object.keys(object).reduce(function (acc, key) {
        if (!isEmptyFn(object[key])) {
            acc[key] = object[key];
        }
        return acc;
    }, {});
}
//# sourceMappingURL=objectClean.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-utilizr/lib/objectClean.js
 ** module id = 312
 ** module chunks = 0
 **/